export default "__VITE_ASSET__0f88b5d1__"